import AuthRoutes from "./AuthRoutes";

export default AuthRoutes;
